import { isDefined } from './defined';
export const mixin = (fn, valueNames = [], defaultValue) => props => {
  const names = [].concat(valueNames);
  for (let i = 0; i < names.length; i++) {
    if (isDefined(props?.[names[i]])) {
      return fn(props[names[i]]);
    }
  }
  return isDefined(defaultValue) ? fn(defaultValue) : '';
};